export const useFocus = ( node: HTMLInputElement ) => node?.focus ? node.focus() : undefined
